import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Active, Over } from '@dnd-kit/core/dist/store/types';
import { ClientRect } from '@dnd-kit/core/dist/types';
import styled from 'styled-components';
import cl from 'classnames';

const Container = styled.div``;

interface DroppableModel {
  isOver?: boolean;
  active?: Active;
  over?: Over;
  node?: React.MutableRefObject<HTMLElement | null>;
  rect?: React.MutableRefObject<ClientRect | null>;
}

interface DroppableProps {
  className?: string;
  id?: string | number;
  htmlId?: string;
  children?: React.ReactNode | ((droppable: DroppableModel) => React.ReactNode);
  style?: React.CSSProperties;
}

export const Droppable = (props: DroppableProps) => {
  const { className, id, htmlId, children, style } = props;
  const droppable = useDroppable({
    id,
  });
  const { isOver, setNodeRef } = droppable;

  return (
    <Container
      id={htmlId}
      className={cl('droppable', className, { 'drag-over': isOver })}
      style={style}
      ref={setNodeRef}
    >
      {typeof children === 'function' ? children(droppable) : children}
    </Container>
  );
};
